<template>
  <ul class="row questionare-list">
    <slot></slot>
  </ul>
</template>

<script>
import { getAccountIdLambdaInvoke } from "@/utils/LambdaHelper";
export default {
  name: "QuestionareList",
  data() {
    return {
      userid: "",
    };
  },
  mounted() {
    try {
      getAccountIdLambdaInvoke().then((res) => {
        this.userid = res;
      });
    } catch (e) {
      this.goToErrorPage(e);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.questionare-list {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
  @include mq-up(md) {
    margin-bottom: 20px;
  }
}
</style>
